import { handleActions } from 'redux-actions'

import * as muteVideoActions from '../actions/muteVideo'

const defaultValue = false

export default handleActions(
  {
    [muteVideoActions.onMuteVideoProgressStateUpdate.toString()](
      state,
      action: ReturnType<typeof muteVideoActions.onMuteVideoProgressStateUpdate>
    ) {
      return action.payload
    },
  },
  defaultValue
)
